import { OVAL_TABLE_DATA } from '../enums/tableNumbers';

export const winNumbersColor = (winNumber) => {
  if (winNumber || winNumber === 0) {
    const winNumberIndex = OVAL_TABLE_DATA.findIndex(item => winNumber === item.value);
    const handleCheckType = () => {
      if (winNumberIndex === 0) {
        return 3;
      }
      if (winNumberIndex === 36) {
        return 5;
      }
      if (winNumberIndex === 1) {
        return 4;
      }
      if (winNumberIndex % 2) {
        return 1;
      } else {
        return 2;
      }
    };
    return {
      numbers: [
        OVAL_TABLE_DATA[winNumberIndex - 1]?.value !== undefined ? OVAL_TABLE_DATA[winNumberIndex - 1]?.value : 26,
        OVAL_TABLE_DATA[winNumberIndex]?.value,
        OVAL_TABLE_DATA[winNumberIndex + 1]?.value !== undefined ? OVAL_TABLE_DATA[winNumberIndex + 1]?.value : 0,
      ],
      type: handleCheckType(),
    };
  }
};
